<script setup lang="ts">
import { MagazineCategoryProps } from "./MagazineCategory.props"

withDefaults(defineProps<MagazineCategoryProps>(), {
  slug: "#"
})
</script>

<template>
  <div
    class="
      magazine-category-wrapper
      cursor-pointer
      overflow-hidden
      rounded-lg
      shadow-01
    "
  >
    <AppLink :to="slug" class="flex h-full flex-col">
      <div class="relative grow-[1]">
        <UtilsWrapperImage
          v-if="image"
          :="image"
          sizes="300px md:500px lg:400px"
          class="wrapper-image-full-container-centered"
        />
      </div>

      <p v-if="title" class="beaver-medium-underlined py-2 text-center">
        {{ title }}
      </p>
    </AppLink>
  </div>
</template>
